import { UserReducer } from "./UserReducer";
import { combineReducers } from "redux";

export const RootReducer = combineReducers({ user: UserReducer });
